import React, { useMemo } from 'react';
import { __ } from '@wordpress/i18n';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useNavigate } from 'react-router-dom';

// tools
import getNumberWithCurrency from '../../helpers/getNumberWithCurrency';

// store
import { useStoreValue } from '../../store';

// components
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';
import WidgetProjects from '../Dashboard/components/WidgetProjects';
import CommCenterProjects from './components/CommCenterProjects';
import ProjectCard from './components/ProjectCard';

const Projects = () => {
    const navigate = useNavigate();
    const projects = useStoreValue('projects');
    const activeProjects = useMemo(() => projects.filter(o => !o.archived), [projects]);

    const goToProject = (id) => {
        navigate(`/projects/${id}`)
    }

    return (
        <>
            <div className="appDashboard">
                <div className="appDashboard__workbench workbenchProjects">
                    <OverlayScrollbarsComponent element="div" style={{ width: '100%', flex: 1, minHeight: 0 }} options={{ scrollbars: { autoHide: 'never' } }} defer>
                    <ul className="projectCards">
                        {activeProjects.map(o => (
                            <ProjectCard key={o.id} project={o} onOpen={goToProject}/>
                        ))}
                    </ul>
                    </OverlayScrollbarsComponent>
                </div>
                <CommCenterProjects/>
            </div>
            <div className="appDashboard__widgets">
                <WidgetProjects/>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Guadagni totali', 'soundbetween')}</h2>
                        <span>{getNumberWithCurrency(0)}</span>
                    </div>
                    <p>{__('Qui potrai tenere sotto controllo l’andamento dei tuoi lavori su Soundbetween', 'soundbetween')}</p>
                </div>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Contatti', 'soundbetween')}</h2>
                        <div>
                            <span>0</span>
                            <ButtonFlat
                                disabled={true}
                                onClick={() => {
                                }}>
                                {__('Aggiungi contatto', 'soundbetween')}
                            </ButtonFlat>
                        </div>
                    </div>
                    <p>{__('Crea il tuo primo progetto per aggiungere persone al tuo network e creare Team', 'soundbetween')}</p>
                </div>
            </div>
        </>
    )
}

export default Projects;